import React, { CSSProperties, FC } from 'react';
import {
  Wrapper,
  Container,
} from './Styles';

const Modal: FC<ModalProps> = ({
  children,
  rounded = true,
  maxWidth,
  minWidth,
  width,
  style,
}) => (
  <Wrapper>
    <Container style={style} rounded={rounded} maxWidth={maxWidth} minWidth={minWidth} width={width}>
      {children}
    </Container>
  </Wrapper>
);

export interface ModalProps {
  children: any;
  rounded?: boolean;
  maxWidth?: string;
  minWidth?: string;
  width?: string;
  style?: CSSProperties;
}

export default Modal;
